import React from "react";
import { Routes, Route } from "react-router-dom";
import { MenuArea, useUpdateMenu } from "core";
import Messages from "self-service/inbox/messages";
import Message from "self-service/inbox/message";

const InboxLayout = () => {
    useUpdateMenu(MenuArea.manage);

    return (
        <section className="inbox">
            <h1>My Messages</h1>

            <Routes>
                <Route path="message/:id" element={<Message />} />
                <Route path="*" element={<Messages />} />
            </Routes>
        </section>
    );
}

export default InboxLayout;